import { MedicalCondition, MedicalConditionConditionType } from "../../../Utilities";

export function splitByConditionType<T extends { medicalCondition: Pick<MedicalCondition, "conditionType"> }>(
	studentMedicalConditions: T[],
) {
	const allergies = [];
	const foodIntolerances = [];
	const medicalConditions = [];

	for (let i = 0; i < studentMedicalConditions.length; i++) {
		const condition = studentMedicalConditions[i];
		switch (condition.medicalCondition.conditionType) {
			case MedicalConditionConditionType.Allergy:
				allergies.push(condition);
				break;
			case MedicalConditionConditionType.FoodIntolerance:
				foodIntolerances.push(condition);
				break;
			case MedicalConditionConditionType.MedicalCondition:
				medicalConditions.push(condition);
				break;
		}
	}

	return {
		allergies,
		foodIntolerances,
		medicalConditions,
	};
}
